import {Site} from "../api/site.ts";
import {createContext, useContext, useState} from "react";

export interface SiteContextType {
    site: Site | null;
    setSite: (site: Site | null) => void;
}

export const SiteContext = createContext<SiteContextType>({
    site: null,
    setSite: () => {}
});

export const useNewSiteContext = (): SiteContextType => {
    const [site, setSite] = useState<Site | null>(null);

    return {site, setSite};
}

export const useSite = (): Site => {
    return useContext(SiteContext).site!;
}

export const useSiteContext = (): SiteContextType => {
    return useContext(SiteContext);
}